import { Region } from './models';

// Default config for 16:9 aspect ratio.
export const DEFAULT_REGIONS: Region[] = [
  // World UI region.
  {
    TOP_LEFT_X: 0.4156,
    TOP_LEFT_Y: 0.2772,
    WIDTH: 0.079,
    HEIGHT_TO_WIDTH_RATIO: 0.18,
    GENE_WIDTH_TO_WIDTH_RATIO: 0.11
  },
  // Inventory region.
  {
    TOP_LEFT_X: 0.6116,
    TOP_LEFT_Y: 0.3422,
    WIDTH: 0.131,
    HEIGHT_TO_WIDTH_RATIO: 0.125,
    GENE_WIDTH_TO_WIDTH_RATIO: 0.08
  }
];
